import React from "react";
import { Form } from "react-bootstrap";
import { useDispatch } from "react-redux";
import {
  setPatternValue,
  setIsAreaTowPatterns,
  setIsAreaThreePatterns,
} from "../redux/Slices/MainSlice";

function PatternSelect(props) {
  const { disabled, changeArea, areaType } = props;
  let dispatch = useDispatch();

  const Onchange = (e) => {
    debugger;
    let val = e.target.value;

    dispatch(setPatternValue(val));
    debugger;

    if (val === "") {
      dispatch(setIsAreaThreePatterns(false));
      dispatch(setIsAreaTowPatterns(false));
    } else {
      if (areaType == "v2") {
        dispatch(setIsAreaTowPatterns(true));
        dispatch(setIsAreaThreePatterns(false));
      } else if (areaType == "v3") {
        dispatch(setIsAreaThreePatterns(true));
        dispatch(setIsAreaTowPatterns(false));
      } else {
        dispatch(setIsAreaThreePatterns(false));
        dispatch(setIsAreaTowPatterns(false));
      }
    }

    val === "" ? changeArea("") : changeArea(areaType);
  };

  return (
    <>
      <Form.Select onChange={Onchange} disabled={disabled}>
        <option value="">Select Pattern </option>
        <option value="Ammo_Cammo"> Ammo Camo </option>
        <option value="Pineapple_Express"> Pineapple Express </option>
        <option value="Pink_Graffitti"> Pink Graffiti </option>
        <option value="Black_Camo"> Black Camo</option>
        <option value="Green_Galaxy"> Green Galaxy </option>
        <option value="Purple_haze"> Purple Haze </option>
        <option value="Blue_Graffitti"> Blue Graffiti </option>
        <option value="Pink_Galaxy"> Pink Galaxy </option>
        <option value="Water_Color"> Water Color </option>
        <option value="Cammo"> Camo </option>
        <option value="Purple_Galaxy"> Purple Galaxy </option>
        <option value="Radbows"> Rad Bows </option>
        <option value="Red_Haze"> Red Haze </option>
        <option value="Spring_Break"> Spring Break </option>
        <option value="Zombie_Unicorn_2"> Zombie Unicorn 2 </option>
        <option value="Stripes"> Stripes </option>
        <option value="Blue_Rock_Candy"> Blue Rock Candy </option>
        <option value="Sugar_Skull_2"> Sugar Skulls 2 </option>
        <option value="Sugar_rush"> Sugar Rush </option>
        <option value="Red_Rockcandy"> Red Rock Candy</option>
        <option value="Lemonade"> Lemonade</option>
      </Form.Select>
    </>
  );
}

export default PatternSelect;
